import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppGpSettings } from '../settings.service';
import { StorageService } from '../../services/storage.service'

/**
Servicio de consulta de tarjetas por cliente
 */
@Injectable()
export class RetrieveCardsByUserService {

  /**
   * url del servicios
   */
  private url = AppGpSettings.URL + "/cards/v1.0/customers/{{customerId}}/cards";

  /**
   * Complementa la url del servicio
   * @param http 
   * @param storageService 
   */
  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {
    this.url = this.url.replace("{{ENV}}", this.storageService.get("ENV")).replace("{{DOM}}", this.storageService.get("DOM"));
  }

  /**
   * Obtiene datos del cliente
   * @param buc 
   */
  get(buc: string): Observable<any> {
    const url = this.url.replace("{{customerId}}", buc);
    return this.http.get(url);
  }

  /**
   * Valida que la lista de cuentas exista en el storage
   * para no realizar varias llamadas
   * se almacenan por 10 min, se renueva desde los componentes:
   *
   * app-cuentas-slider
   *
   */
   checkStorage(): boolean {
    const accounts = this.storageService.get('accounts');
    let response = false;
    if (accounts) {
      if (Date.now() < accounts.expire) {
        response = true;
      }
    }
    return response;
  }

}
